<template>
    <div id="popup-map" class="popup-wrap" :class="onModalClass" role="dialog" ref="cursor">
        <div class="popup-header">
            <h1>지도보기</h1>
            <button class="close-btn" aria-label="상세보기 화면 닫기" @click="doCloseWinMap"></button>
        </div>
        <div class="popup-conts">
            <MapConatiner />
        </div>
    </div>
</template>

<script setup>
    defineOptions({
        name: 'MapView',
    });

    import { onMounted, ref } from 'vue';
    import MapConatiner from '@/components/map/MapConatiner.vue';

    const emit = defineEmits(['close']);

    const onModalClass = ref('popup-wrap slideUp');
    const isModal = ref(false);

    // [X]버튼 클릭시
    const doCloseWinMap = () => {
        // css상태를 slideDown상태로 변경
        onModalClass.value = 'slideDown';
        document.body.classList.remove('no-scroll');

        if (isModal.value) {
            // 모달여부 초기화
            isModal.value = false;
        }

        // 약간의 딜레이 후 close 이벤트 발생
        setTimeout(() => {
            emit('close');
        }, 200);
    };
    const setMapEnv = async () => {
        // 팝업 CSS 설정
        onModalClass.value = 'slideUp';

        // 모달설정
        isModal.value = true;
    };

    onMounted(() => {
        isModal.value = true;

        window.onpopstate = () => {
            // 브라우저 뒤로가기시 지도화면만 닫기
            doCloseWinMap();
        };
    });

    defineExpose({ setMapEnv });
</script>
